import styled from 'styled-components';
import { Accordion } from 'ui/accordion';
import { spacing } from 'ui/theme';

export const TriggerEventDiv = styled.div`
  padding-top: ${spacing.half};
`;

export const RedText = styled.span`
  color: #d14233;
  background-color: transparent;
  &[data-highlight='true'] {
    background-color: #f9f2f4;
  }
`;

export const StyledAccordion = styled(Accordion)`
  padding: 0;
  background-color: transparent;
`;
